var map = {
	"./activity_space.svg": "20d9",
	"./add-circle.svg": "a770",
	"./add-file.svg": "adf5",
	"./add-icon.svg": "3410f",
	"./ai-tips.svg": "cce0",
	"./analy-image.svg": "c4d2",
	"./arrow-left.svg": "87ff",
	"./arrow-right-not.svg": "d52d",
	"./arrow-right.svg": "2d08",
	"./audio-icon.svg": "e422",
	"./big.svg": "fb6e",
	"./black-like.svg": "607b",
	"./book-line-white.svg": "3377",
	"./book-line.svg": "331a8",
	"./canvas-brush.svg": "4898",
	"./canvas-clean.svg": "52d9",
	"./canvas-note.svg": "cbb8",
	"./canvas-rubber.svg": "2c6b",
	"./canvas-save-course.svg": "27f0",
	"./canvas-save.svg": "a0b9",
	"./canvas-text.svg": "1b66",
	"./caret-down-small.svg": "7276",
	"./check-num.svg": "fa40",
	"./check-type-select.svg": "6ebd",
	"./check-type.svg": "5ac5",
	"./chevron-left-disable.svg": "2ed4",
	"./chevron-left.svg": "abe1",
	"./chevron-right-disable.svg": "82b0",
	"./chevron-right.svg": "8a7c",
	"./class-num.svg": "a678",
	"./classLeader.svg": "af3a",
	"./clear-day.svg": "dd99",
	"./clear-night.svg": "bdef",
	"./close.svg": "0426",
	"./cloudy.svg": "5acb",
	"./collected.svg": "a0b8",
	"./common-icon.svg": "601e",
	"./course-cover.svg": "1c4a",
	"./course-create.svg": "c080",
	"./course-exercise.svg": "9ae3",
	"./course-order.svg": "2f09",
	"./course-paper.svg": "36d3",
	"./course-refresh.svg": "d4db",
	"./course-submit.svg": "4cdb",
	"./cover.svg": "3eab",
	"./data-icon.svg": "1975",
	"./db-analys.svg": "e9c7",
	"./default-avatar.svg": "7034",
	"./delete-blue.svg": "03a9",
	"./delete-icon.svg": "5bbf",
	"./delete-white.svg": "f991",
	"./delete.svg": "a063",
	"./dialog-close-white.svg": "f2c5",
	"./dialog-close.svg": "aa8e",
	"./discuss-logo.svg": "a0c0",
	"./down-disabled.svg": "0afe",
	"./down.svg": "9534",
	"./edit.svg": "84c3",
	"./empty-content.svg": "5971",
	"./empty-icon.svg": "d8cb",
	"./empty-table.svg": "0c71",
	"./eva-add.svg": "7855",
	"./execise-num.svg": "614b",
	"./exhibition.svg": "a76d",
	"./eye.svg": "4dc4",
	"./face-excellent.svg": "00d0",
	"./face-qualified.svg": "0303",
	"./face-unqualified.svg": "0e19",
	"./file-audio.svg": "f886",
	"./file-doc.svg": "5e6a",
	"./file-excel.svg": "03dc",
	"./file-image.svg": "0e48",
	"./file-other.svg": "ac21",
	"./file-pdf.svg": "c629",
	"./file-ppt.svg": "4fd0",
	"./file-video.svg": "5a03",
	"./file-zip.svg": "12cf",
	"./flag-active.svg": "2529",
	"./flag.svg": "c693",
	"./fog.svg": "f575",
	"./group-icon.svg": "6e91",
	"./haze.svg": "8fb9",
	"./heavy-rain.svg": "789b",
	"./heavy-snow.svg": "78a4",
	"./home-more.svg": "9f86",
	"./home_space.svg": "327f",
	"./image-circel.svg": "a317",
	"./image-delete.svg": "65bc",
	"./img-circle.svg": "4780",
	"./info-circle.svg": "2972",
	"./join-num.svg": "cf23",
	"./light-rain.svg": "ea9d",
	"./light-snow.svg": "9e57",
	"./logo.svg": "40e1",
	"./logout.svg": "157f",
	"./mark.svg": "7384",
	"./moderate-rain.svg": "537c",
	"./moderate-snow.svg": "4d7f",
	"./move.svg": "05b9",
	"./move2.svg": "db84",
	"./noData.svg": "b1e6",
	"./num-icon.svg": "0b41",
	"./partly-cloudy-day.svg": "aa3f",
	"./partly-cloudy-night.svg": "4f0a",
	"./person-search.svg": "7b04",
	"./play.svg": "b10a",
	"./plus.svg": "4945",
	"./prepare-icon.svg": "fac4",
	"./red-star.svg": "5a54",
	"./reset.svg": "4c88",
	"./resource-download.svg": "cd29",
	"./resource-save.svg": "d65d",
	"./searchBox.svg": "a03d",
	"./select.svg": "f9ac",
	"./setting.svg": "9787",
	"./slide-ai-entry.svg": "ee69",
	"./slide-bei.svg": "75eb",
	"./slide-fu.svg": "7e3e",
	"./slide-gai.svg": "739d",
	"./slide-guan.svg": "7084",
	"./slide-jiao.svg": "d630",
	"./slide-ping.svg": "d4ed",
	"./slide-yan.svg": "ea57",
	"./sort.svg": "0bbb2",
	"./sort2.svg": "562a",
	"./star.svg": "d2e2",
	"./storm-rain.svg": "ddae",
	"./storm-snow.svg": "3b1c",
	"./submit-num.svg": "f0f0",
	"./swap.svg": "f560",
	"./swaps.svg": "831c",
	"./task-icon.svg": "3ddb",
	"./teach-all-time.svg": "f34b",
	"./teach-num.svg": "5eb4",
	"./teach-time.svg": "5f3e",
	"./teacher-analy.svg": "4592",
	"./teacher-detail.svg": "6b49",
	"./teacher-num.svg": "1aed",
	"./tip-info.svg": "904a",
	"./top-num.svg": "b0b5",
	"./un-star.svg": "bac0",
	"./unCollect.svg": "ba96",
	"./up-disabled.svg": "3296",
	"./up.svg": "fc99",
	"./use.svg": "d925",
	"./video-play.svg": "3b71",
	"./vip-icon.svg": "6e84",
	"./wind.svg": "3170",
	"./xkw.svg": "08ea",
	"./zzxx.svg": "edf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fdd4";